import { useField, useFormikContext } from 'formik';
import { type ChangeEvent, type FC } from 'react';

import { ODSTextField } from '../../InputFields';

import type { FormikTextFieldProps, ODSTextFieldPropsType } from '@/types/inputTypes';

export const FormikTextField: FC<FormikTextFieldProps & ODSTextFieldPropsType> = ({
  name,
  label,
  placeholder = '',
  disabled = false,
  onChange: propOnChange = null,
  InputProps,
  size,
  ...otherProps
}) => {
  const [field, meta] = useField<string>(name);
  const { values, setFieldValue, setFieldError } = useFormikContext<Record<string, unknown>>();
  const isDisabled = typeof disabled === 'string' ? !values[disabled] : disabled;

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setFieldValue(name, event.target.value);
    if (propOnChange) {
      propOnChange(event, {
        setFieldValue: setFieldValue as keyof typeof setFieldValue,
        setFieldError,
      });
    }
  };

  return (
    <ODSTextField
      name={field.name}
      value={field.value}
      onChange={handleChange}
      onBlur={field.onBlur}
      label={label}
      placeholder={placeholder}
      disabled={isDisabled}
      {...(meta.touched && { helperText: meta.error })}
      {...(InputProps && { InputProps })}
      {...(size && { size })}
      {...otherProps}
    />
  );
};
